import { render, staticRenderFns } from "./EmailApp.vue?vue&type=template&id=473bd3f0&"
import script from "./EmailApp.vue?vue&type=script&lang=js&"
export * from "./EmailApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports